define([
	"dojo/_base/declare",
	"Specification/ProductAlternativeSwitchboard"
], function(declare,ProductAlternativeSwitchboard) {

	return declare(ProductAlternativeSwitchboard, {
		switchboardPath: "Child:ThemeProductAlternatives"
	});
});